let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("45s1S")).then(() => parcelRequire('3zdsZ'));